import { controller } from '../../utilities/abortController'
import { EdgeApiResponse } from './utilities'

export interface PrivateGalleryUser {
    username: string
    online: number
    color: string
    font: string
    font_flags: number
}

export interface MergedPrivateGalleryUser extends PrivateGalleryUser {
    id: number
    gallery?: Array<string>
}

export interface IPrivateGalleryResult {
    collection: Array<number>
    galleries: {
        [key: string]: Array<Array<string>>
    }
    users: {
        [key: string]: PrivateGalleryUser
    }
}

export type IPrivateGalleryResponse = EdgeApiResponse<IPrivateGalleryResult>

export const getGalleryData = async (): Promise<IPrivateGalleryResponse> => {
    const url = `https://api-edge.myfreecams.com/exclusiveGallery/`
    const options = {
        credentials: 'include' as const,
        headers: {
            'Content-Type': 'application/json',
        },
        signal: controller.signal,
    }
    const response = await fetch(url, options)
    return await response.json()
}

export const getIndividualGallery = async (
    id,
): Promise<IPrivateGalleryResponse> => {
    const url = `https://api-edge.myfreecams.com/exclusiveGallery/${id}`
    const options = {
        credentials: 'include' as const,
        headers: {
            'Content-Type': 'application/json',
        },
        signal: controller.signal,
    }
    const response = await fetch(url, options)
    return await response.json()
}
